// extracted by mini-css-extract-plugin
module.exports = {"arrow":"Carousel_arrow__Uglcn"};